export interface TutorialStep {
  spotId: string
  text: string
  action: 'click' | 'next' | 'wait'
  waitForSpot?: boolean
}

export interface TutorialSeries {
  id: string
  steps: TutorialStep[]
  completionText: string
}

export const TUTORIAL_GETTING_STARTED: TutorialSeries = {
  id: 'getting-started',
  steps: [
    {
      spotId: 'dashboard-projects-card',
      text: 'Klicke auf "Projekte", um deine Projekte zu verwalten.',
      action: 'click',
    },
    {
      spotId: 'projects-new-button',
      text: 'Erstelle dein erstes Projekt.',
      action: 'wait',
    },
    {
      spotId: 'projects-newest-row',
      text: 'Klicke auf dein neues Projekt, um es zu bearbeiten.',
      action: 'click',
      waitForSpot: true,
    },
    {
      spotId: 'album-load-examples',
      text: 'Lade Beispiel-Bilder, um zu sehen, wie dein Album aussieht.',
      action: 'click',
      waitForSpot: true,
    },
    {
      spotId: 'design-tab',
      text: 'Wechsle zum Design-Tab, um das Aussehen deiner Galerie anzupassen.',
      action: 'click',
      waitForSpot: true,
    },
    {
      spotId: 'design-theme-select',
      text: 'Wähle ein Theme aus, um das Design deiner Galerie zu ändern.',
      action: 'wait',
      waitForSpot: true,
    },
    {
      spotId: 'design-save-button',
      text: 'Speichere deine Änderungen.',
      action: 'click',
      waitForSpot: true,
    },
  ],
  completionText: 'Super! Du hast das Tutorial abgeschlossen. Viel Spaß mit heyalbum!',
}

export const ALL_TUTORIALS: Record<string, TutorialSeries> = {
  [TUTORIAL_GETTING_STARTED.id]: TUTORIAL_GETTING_STARTED,
}
